import { IBuilder, Builder } from 'builder-pattern';

export interface ForumCategoryInterface {
  id: number;
  name: string;
  description: string;
  displayOrder: number;
  isActive: boolean;
  threadCount?: number;
  createdAt: string;
  updatedAt: string;
}

export namespace ForumCategoryInterface {
  export function builder(
    template?: Partial<ForumCategoryInterface>
  ): IBuilder<ForumCategoryInterface> {
    return Builder<ForumCategoryInterface>(template);
  }
}